import React from 'react'

export default () => {
  return (
    <div style={{userSelect:"none"}}>
      <h1 className="display-4"><span className="text-danger">404</span> Page Not Found</h1>
      <p className="lead">Weird Things Happen 😂😅</p>
      <p>Try to get along with that 😁</p>
    </div>
  )
}
